<div class="container-xl px-xl-0 mb-5 ml-0">
	<div class="row">
		<div class="col-12">
			<h3 class="table-section-title">
				{{ 'presence-signature_section-title' | translate }}
			</h3>

			<!-- Respondant/Sponsor View -->
			<div class="table-container" *ngIf="!isFormateurView">
				<table>
					<thead>
						<tr>
							<th>
								{{
									'presence-signature_table-date' | translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-period'
										| translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-state' | translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-action'
										| translate
								}}
							</th>
						</tr>
					</thead>
					<tbody>
						<ng-container
							*ngFor="
								let row of signatureRows;
								trackBy: trackByDate
							"
						>
							<tr>
								<td class="date">
									{{
										row.date
											| date
												: 'dd MMMM yyyy'
												: ''
												: 'fr-FR'
									}}
								</td>
								<td class="period">
									{{ getPeriodLabel(row.period) }}
								</td>
								<td
									class="state"
									[ngClass]="row.status"
									[ngSwitch]="row.status"
								>
									<ng-container
										*ngSwitchCase="'need-sign-now'"
									>
										<div
											class="signature-action-link"
											(click)="navigateToSignature(row)"
										>
											{{
												'presence-signature_status-need-sign-now'
													| translate
											}}
										</div>
									</ng-container>
									<ng-container
										*ngSwitchCase="'already-signed'"
									>
										<span
											class="d-flex align-items-center justify-content-center"
										>
											<i
												nz-icon
												nzType="check-circle"
												nzTheme="fill"
												class="mr-2"
												[style.color]="
													colorThematique.props.main
												"
											></i>
											<span>
												{{
													'presence-signature_status-already-signed'
														| translate
												}}
											</span>
										</span>
									</ng-container>
									<ng-container *ngSwitchCase="'sign-later'">
										<span>
											{{
												'presence-signature_status-sign-later'
													| translate
											}}
										</span>
									</ng-container>
									<ng-container
										*ngSwitchCase="'too-late-to-sign'"
									>
										<span class="text-muted">
											{{
												'presence-signature_status-too-late-to-sign'
													| translate
											}}
										</span>
									</ng-container>
								</td>
								<td class="action">
									<button
										*ngIf="row.status === 'need-sign-now'"
										nz-button
										nzType="primary"
										(click)="navigateToSignature(row)"
									>
										{{
											'presence-signature_action-sign'
												| translate
										}}
									</button>
									<span
										*ngIf="row.status !== 'need-sign-now'"
										class="no-action"
										>-</span
									>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>

			<!-- Formateur View -->
			<div class="formateur-view" *ngIf="isFormateurView">
				<!-- Formateur's Own Signatures Section -->
				<div class="formateur-own-signatures mb-4">
					<h4 class="section-subtitle">
						{{ 'presence-signature_my-presence' | translate }}
					</h4>
					<div class="table-container">
						<table>
							<thead>
								<tr>
									<th>
										{{
											'presence-signature_table-date'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-period'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-state'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-action'
												| translate
										}}
									</th>
								</tr>
							</thead>
							<tbody>
								<ng-container
									*ngFor="
										let row of formateurOwnSignatures;
										trackBy: trackByDate
									"
								>
									<tr>
										<td class="date">
											{{
												row.date
													| date
														: 'dd MMMM yyyy'
														: ''
														: 'fr-FR'
											}}
										</td>
										<td class="period">
											{{ getPeriodLabel(row.period) }}
										</td>
										<td
											class="state"
											[ngClass]="row.status"
											[ngSwitch]="row.status"
										>
											<ng-container
												*ngSwitchCase="'need-sign-now'"
											>
												<div
													class="signature-action-link"
													(click)="
														navigateToSignature(row)
													"
												>
													{{
														'presence-signature_status-need-sign-now'
															| translate
													}}
												</div>
											</ng-container>
											<ng-container
												*ngSwitchCase="'already-signed'"
											>
												<span
													class="d-flex align-items-center justify-content-center"
												>
													<i
														nz-icon
														nzType="check-circle"
														nzTheme="fill"
														class="mr-2"
														[style.color]="
															colorThematique
																.props.main
														"
													></i>
													<span>
														{{
															'presence-signature_status-already-signed'
																| translate
														}}
													</span>
												</span>
											</ng-container>
											<ng-container
												*ngSwitchCase="'sign-later'"
											>
												<span>
													{{
														'presence-signature_status-sign-later'
															| translate
													}}
												</span>
											</ng-container>
											<ng-container
												*ngSwitchCase="
													'too-late-to-sign'
												"
											>
												<span class="text-muted">
													{{
														'presence-signature_status-too-late-to-sign'
															| translate
													}}
												</span>
											</ng-container>
										</td>
										<td class="action">
											<button
												*ngIf="
													row.status ===
													'need-sign-now'
												"
												nz-button
												nzType="primary"
												(click)="
													navigateToSignature(row)
												"
											>
												{{
													'presence-signature_action-sign'
														| translate
												}}
											</button>
											<span
												*ngIf="
													row.status !==
													'need-sign-now'
												"
												class="no-action"
												>-</span
											>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>

				<!-- Stagiaires Signatures Section -->
				<h4 class="section-subtitle mt-4">
					{{ 'presence-signature_stagiaires-presence' | translate }}
				</h4>

				<!-- Editable Window Alert -->
				<div
					*ngIf="!isWithinFormateurEditableWindow"
					class="alert alert-info mb-3"
					style="
						background-color: #e6f7ff;
						border: 1px solid #91d5ff;
						padding: 12px 15px;
						border-radius: 4px;
					"
				>
					<i
						nz-icon
						nzType="info-circle"
						nzTheme="outline"
						style="color: #1890ff; margin-right: 8px"
					></i>
					<span style="color: #0050b3">
						{{
							'presence-signature_alert-editable-window-ended'
								| translate
						}}
					</span>
				</div>

				<div
					*ngFor="let group of formateurGroups; trackBy: trackByGroup"
					class="group-section"
				>
					<!-- Collapsible Header -->
					<div
						class="group-header"
						(click)="toggleGroup(group)"
						[class.expanded]="isGroupExpanded(group)"
					>
						<i
							nz-icon
							[nzType]="
								isGroupExpanded(group)
									? 'minus-circle'
									: 'plus-circle'
							"
							nzTheme="outline"
							class="expand-icon"
						></i>
						<h4 class="group-title">
							{{
								group.date
									| date : 'dd MMMM yyyy' : '' : 'fr-FR'
							}}
							- {{ getPeriodLabel(group.period) }}
						</h4>
						<span
							class="stagiaire-count"
							[class.has-missing]="
								getMissingSignaturesCount(group) > 0
							"
						>
							<ng-container
								*ngIf="getMissingSignaturesCount(group) > 0"
							>
								{{
									'presence-signature_count-missing'
										| translate
											: {
													count: getMissingSignaturesCount(
														group
													)
											  }
								}}
							</ng-container>
							<ng-container
								*ngIf="getMissingSignaturesCount(group) === 0"
							>
								{{
									'presence-signature_count-complete'
										| translate
								}}
							</ng-container>
							<ng-container *ngIf="getExcusedCount(group) > 0">
								·
								{{
									'presence-signature_count-excused'
										| translate
											: {
													count: getExcusedCount(
														group
													)
											  }
								}}
							</ng-container>
						</span>
					</div>

					<!-- Stagiaires Table -->
					<div
						*ngIf="isGroupExpanded(group)"
						class="stagiaires-container"
					>
						<table class="stagiaires-table">
							<thead>
								<tr>
									<th>
										{{
											'presence-signature_table-name'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-state'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-signed-at'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-absence'
												| translate
										}}
									</th>
									<th>
										{{
											'presence-signature_table-action'
												| translate
										}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									*ngFor="
										let stagiaire of group.stagiaires;
										trackBy: trackByStagiaire
									"
								>
									<td class="stagiaire-name">
										{{ stagiaire.stagiaire_name }}
									</td>
									<td class="stagiaire-status">
										<span
											*ngIf="stagiaire.signed"
											class="d-flex align-items-center"
										>
											<i
												nz-icon
												nzType="check-circle"
												nzTheme="fill"
												class="mr-2"
												[style.color]="
													colorThematique.props.main
												"
											></i>
											<span>
												{{
													'presence-signature_status-already-signed'
														| translate
												}}
											</span>
										</span>
										<span
											*ngIf="stagiaire.excused"
											class="d-flex align-items-center"
										>
											<i
												nz-icon
												nzType="minus-circle"
												nzTheme="fill"
												class="mr-2"
												style="color: #fa8c16"
											></i>
											<span>
												{{
													'presence-signature_status-excused'
														| translate
												}}
											</span>
										</span>
										<span
											*ngIf="
												!stagiaire.signed &&
												!stagiaire.excused
											"
											class="d-flex align-items-center"
										>
											<i
												nz-icon
												nzType="close-circle"
												nzTheme="outline"
												class="mr-2"
												style="color: #999"
											></i>
											<span>
												{{
													'presence-signature_status-not-signed'
														| translate
												}}
											</span>
										</span>
									</td>
									<td class="signed-at">
										<span *ngIf="stagiaire.signed_at">
											{{
												stagiaire.signed_at
													| date
														: 'dd/MM/yyyy HH:mm'
														: ''
														: 'fr-FR'
											}}
										</span>
										<span *ngIf="!stagiaire.signed_at"
											>-</span
										>
									</td>
									<td class="delay">
										<span
											*ngIf="
												stagiaire.delay &&
												stagiaire.delay > 0
											"
											class="delay-badge"
										>
											{{ stagiaire.delay }} min
										</span>
										<span
											*ngIf="
												!stagiaire.delay ||
												stagiaire.delay === 0
											"
											>-</span
										>
									</td>
									<td class="action">
										<button
											*ngIf="
												stagiaire.signed &&
												isWithinFormateurEditableWindow
											"
											nz-button
											nzType="default"
											nzSize="small"
											(click)="
												openDelayModal(stagiaire, group)
											"
										>
											{{
												'presence-signature_action-edit-absence'
													| translate
											}}
										</button>
										<button
											*ngIf="
												stagiaire.signed &&
												stagiaire.attestation_id &&
												!hasPendingRemoval(
													stagiaire.attestation_id
												)
											"
											nz-button
											nzType="default"
											nzDanger
											nzSize="small"
											class="ml-2"
											[nzLoading]="
												isRemovalInFlight(
													stagiaire.attestation_id
												)
											"
											(click)="
												proposeSignatureRemoval(
													stagiaire.attestation_id
												)
											"
										>
											{{
												'signature-removal-request_propose-button'
													| translate
											}}
										</button>
										<span
											*ngIf="
												stagiaire.signed &&
												stagiaire.attestation_id &&
												hasPendingRemoval(
													stagiaire.attestation_id
												)
											"
											class="pending-removal-badge ml-2"
										>
											{{
												'signature-removal-request_pending-badge'
													| translate
											}}
										</span>
										<button
											*ngIf="
												!stagiaire.signed &&
												!stagiaire.excused &&
												isWithinFormateurEditableWindow
											"
											nz-button
											nzType="primary"
											nzSize="small"
											(click)="
												openDelayModal(stagiaire, group)
											"
										>
											{{
												'presence-signature_action-sign'
													| translate
											}}
										</button>
										<button
											*ngIf="
												!stagiaire.signed &&
												!stagiaire.excused &&
												isWithinFormateurEditableWindow
											"
											nz-button
											nzType="default"
											nzSize="small"
											class="ml-2"
											[nzLoading]="
												isExcuseInFlight(
													stagiaire,
													group
												)
											"
											(click)="
												toggleExcused(stagiaire, group)
											"
										>
											{{
												'presence-signature_action-excuse'
													| translate
											}}
										</button>
										<button
											*ngIf="
												stagiaire.excused &&
												isWithinFormateurEditableWindow
											"
											nz-button
											nzType="default"
											nzSize="small"
											[nzLoading]="
												isExcuseInFlight(
													stagiaire,
													group
												)
											"
											(click)="
												toggleExcused(stagiaire, group)
											"
										>
											{{
												'presence-signature_action-unexcuse'
													| translate
											}}
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- Delay Management Modal -->
<nz-modal
	[(nzVisible)]="delayModalVisible"
	[nzTitle]="delayModalTitle"
	(nzOnCancel)="closeDelayModal()"
	(nzOnOk)="submitDelayModal()"
	[nzOkText]="'presence-signature_modal-ok' | translate"
	[nzCancelText]="'presence-signature_modal-cancel' | translate"
	[nzOkLoading]="delayModalLoading"
>
	<ng-container>
		<div class="generate-popup">
			<div class="form-group">
				<label>
					{{ 'presence-signature_modal-absence-label' | translate }}
				</label>
				<input
					nz-input
					type="number"
					[(ngModel)]="delayValue"
					min="0"
					placeholder="0"
					name="delayValue"
				/>
			</div>
		</div>
	</ng-container>
</nz-modal>
